export const hrViewi18n = {
  hrSettings: {
    empty: {
      heading: 'No company-country pair visible',
      message:
        'As soon as there are active employees in the countries for which you are responsible, it will be possible to access the page correctly.',
    },
  },
  hrSupport: {
    empty: {
      heading: 'No country visible',
      message: 'You must be responsible for at least one country to access the page correctly.',
    },
  },
}
